import module from 'finanzas/module.js'
import template from './template.html'

module.config(($stateProvider) => {
  $stateProvider.state('finances.comisionistas', {
    url: '/comisionistas?{start:date}&{end:date}&:ids_comisionistas',
    data: {
      title: 'Comisionistas',
    },
    params: {
      ids_comisionistas: {
        array: true,
      },
    },
    resolve: {
      comisionistas: ['Comisionistas', function (Comisionistas) {
        return Comisionistas.obtenerComisionistas();
      }],

      Datos: ['Comisionistas', '$stateParams', function (Comisionistas, $stateParams) {
        var start = $stateParams.start,
          end = $stateParams.end,
          ids_comisionistas = $stateParams.ids_comisionistas;

        return start && end && ids_comisionistas ? Comisionistas.obtenerReporte(start, end, ids_comisionistas) : undefined;
      }],
    },
    template,
    controllerAs: '$ctrl',
    controller (comisionistas, $moment, Datos, $location, $stateParams, Comisionistas) {
      var $ctrl = this;

      $ctrl.Datos = Datos;

      $ctrl.comisionistas = comisionistas;

      $ctrl.obtenerInformacion = obtenerInformacion;
      $ctrl.seleccionar = seleccionar;
      $ctrl.exportar = exportar;
      $ctrl.seleccionado = '';

      var hoy = $moment().startOf('month').toDate(),
        antes = $moment().startOf('month').subtract(12, 'months').toDate();

      $ctrl.opciones = {
        comisionistas: $stateParams.ids_comisionistas || [],
        start: $stateParams.start || antes,
        end: $stateParams.end || hoy,
      };

      if ($ctrl.Datos) {
        $ctrl.encabezados = encabezados(angular.copy($ctrl.opciones.start), $ctrl.opciones.end);
        $ctrl.DatosNuevos = formarDetalles($ctrl.Datos);
      }

      function obtenerInformacion () {
        $location.search({
          start: $ctrl.opciones.start.toYMD(),
          end: $ctrl.opciones.end.toYMD(),
          ids_comisionistas: $ctrl.opciones.comisionistas,
        });
      }

      function encabezados (d1, d2) {
        var meses = monthDiff(d1, d2),
          mesesanio = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiempre', 'Octubre', 'Noviembre', 'Diciciembre'],
          encabezadoMeses = [],
          encabezado = '';
        for (var i = 0; i < meses; i++) {
          encabezado = mesesanio[d1.getMonth()] + '_' + d1.getFullYear();
          encabezadoMeses.push(encabezado);
          d1.setMonth(d1.getMonth() + 1);
        }
        return encabezadoMeses;
      }

      function formarDetalles (data) {
        var detalles = [],
          propiedades;
        data.forEach(function (item) {
          $ctrl.encabezados.forEach(function (elemento) {
            propiedades = elemento.split('_');
            detalles.push({
              mes: propiedades[0],
              anio: propiedades[1],
              valor: item[elemento],
            });
          });
          item.DejoDeTrabajar = parseFloat(detalles[detalles.length - 1].valor) > 0 ? true : false;
          item.Facturacion = detalles;
          detalles = [];
        });
        return data;
      }

      function monthDiff (d1, d2) {
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth() + 1;
        months += d2.getMonth();
        return months <= 0 ? 0 : months + 2;
      }

      function seleccionar (item) {
        if (item) {
          $ctrl.seleccionado = item;
        } else {
          $ctrl.seleccionado = null;
        }
      }

      function exportar () {
        Comisionistas
          .exportarXLS($ctrl.DatosNuevos, 'Comisionistas');
      }

    },
  });
})



// WEBPACK FOOTER //
// ./src/finanzas/_/comisionistas/controller.js